var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{staticClass:"mt-3",attrs:{"show-empty":"","bordered":"","small":"","stacked":"md","head-variant":"light","items":_vm.commissionsSelected,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }